import { render, staticRenderFns } from "./PasswordReminder.vue?vue&type=template&id=4f998092&scoped=true&lang=pug&"
import script from "./PasswordReminder.vue?vue&type=script&lang=ts&"
export * from "./PasswordReminder.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordReminder.vue?vue&type=style&index=0&id=4f998092&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f998092",
  null
  
)

export default component.exports